import { render, staticRenderFns } from "./AmazeSquiggle.vue?vue&type=template&id=c9be8f44"
import script from "./AmazeSquiggle.vue?vue&type=script&lang=js"
export * from "./AmazeSquiggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports